import {Component} from '@angular/core';
import {AbstractAction} from '../abstract-action';

@Component({
    selector: 'vui-icon-action',
    templateUrl: './icon-action.component.html',
    styleUrls: ['./icon-action.component.scss']
})
export class IconActionComponent extends AbstractAction {
    constructor() {
        super();
    }
}
